module.exports = "/_next/static/images/WOW-9560e396b5f51813aa0445e12d1aa871.jpg";